import React from "react";
import { LegalPage } from "./legal/LegalPage";

const SecurityUses = () => <LegalPage namespace="legalSecurityUses" />;

export default SecurityUses;
